module.exports = __webpack_public_path__ + "img/sliders.bf1f4acb.svg";